// app/javascript/controllers/dismissible_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        // Check if already dismissed in this session
        const bannerId = this.element.dataset.bannerId || 'plan-limit-banner'
        if (sessionStorage.getItem(`dismissed-${bannerId}`)) {
            this.element.style.display = 'none'
        }
    }

    dismiss() {
        const bannerId = this.element.dataset.bannerId || 'plan-limit-banner'

        // Animate out
        this.element.style.transition = 'all 0.3s ease'
        this.element.style.opacity = '0'
        this.element.style.transform = 'translateY(-10px)'

        // Remove after animation and persist dismissal
        setTimeout(() => {
            this.element.style.display = 'none'
            sessionStorage.setItem(`dismissed-${bannerId}`, 'true')
        }, 300)
    }

    disconnect() {
        // No cleanup needed
    }
}
